import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Tilt from 'react-tilt';


const HeaderImg = ({ filename, alt }) => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 1234) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const image = data.images.edges.find((n) => n.node.relativePath.includes(filename));

      if (!image) return null;

      const imageFluid = image.node.childImageSharp.fluid;

      return <Tilt
      options={{
        reverse: false,
        max: 8,
        perspective: 500,
        scale: 1.05,
        speed: 800,
        transition: true,
        axis: null,
        reset: true,
        easing: 'cubic-bezier(.03,.98,.52,.99)',
      }}
    >
      <div data-tilt className="thumbnail rounded">
        <Img alt={alt} fluid={imageFluid}/>
      </div>
    </Tilt>

      //return <Img alt={alt} fluid={imageFluid} />;
    }}
  />
);

HeaderImg.propTypes = {
  filename: PropTypes.string,
  alt: PropTypes.string,
};

export default HeaderImg;
